export interface PendingReply {
  id: string;
  storeId: string;
  conversationRootId: string;
  selectedMessageId: string;
  serverMessageId?: string;
  state: 'sending' | 'sent' | 'failed';
  error?: string;
  bodyText: string;
  filenames: string[];
  draft: { to: string; cc: string; bcc: string; subject: string; bodyHtml: string; parentId: string };
}

interface Thread {
  id: string;
  conversationRootId?: string | null;
  replies?: Array<{ id: string }>;
}

export function visiblePendingReplies(pending: PendingReply[], storeId: string, thread: Thread | null) {
  if (!thread) return [];
  const ids = new Set([thread.id, ...(thread.replies || []).map(reply => reply.id)]);
  return pending.filter(reply => reply.storeId === storeId
    && (reply.conversationRootId === (thread.conversationRootId || thread.id) || ids.has(reply.selectedMessageId))
    && (!reply.serverMessageId || !ids.has(reply.serverMessageId)));
}
